var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`label label-${_vm.color}`,attrs:{"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }